/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-24T16:23:29.583
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialPaymentItem,
	listFinancialPaymentItemInit,
	listFinancialPaymentItemByAuthorizations,
	deleteFinancialPaymentItem
} from '@api/financial/FinancialPaymentItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialPaymentItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPaymentItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPaymentItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPaymentItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPaymentItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPaymentItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPaymentItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPaymentItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
